function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M21.7753 3.36805L2.33981 11.6134C1.90173 11.7993 1.94645 12.4342 2.40626 12.5568L10.7362 14.7781C10.8031 14.796 10.8656 14.8275 10.9197 14.8708L18.3917 20.8484C18.6849 21.083 19.1223 20.9228 19.1947 20.5544L22.4612 3.92471C22.5385 3.53125 22.1444 3.21145 21.7753 3.36805Z",
  stroke: "#627080",
  strokeWidth: 1.5
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.1169 17.4286L11.7218 20.3027C11.4224 20.662 10.8376 20.4503 10.8376 19.9826V15.0165C10.8376 14.8814 10.8923 14.7521 10.9891 14.658L22.6428 3.32794",
  stroke: "#627080",
  strokeWidth: 1.5
});

const SvgSend = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSend, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Send.211b9303.svg";
export { ForwardRef as ReactComponent };